/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarkerChangeParameters,
  MarkerCreationResult,
  ProjectMarker,
  ProjectMarkerCreateParameters,
  ProjectMarkersCreateParameters,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectMarkersClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectMarkers
   * @summary Получение маркеров в проекте.
   * @request GET:/geology/project/{projectId}/marker
   * @secure
   */
  projectMarkersGetMarkersForProject = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectMarker[], any>({
      path: `/geology/project/${projectId}/marker`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectMarkers
 * @summary Добавляет маркеры в проект, привязывая их к скважинам.
Дополнительные скважины не добавляются
 * @request POST:/geology/project/{projectId}/marker
 * @secure
 */
  projectMarkersAddMarkersToProjectWell = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<string[], void>({
      path: `/geology/project/${projectId}/marker`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectMarkers
   * @summary Создаёт один новый проектный маркер.
   * @request PUT:/geology/project/{projectId}/marker
   * @secure
   */
  projectMarkersCreateProjectMarker = (
    projectId: string,
    data: ProjectMarkerCreateParameters,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/geology/project/${projectId}/marker`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectMarkers
   * @summary Получение имён маркеров для проекта
   * @request GET:/geology/project/{projectId}/marker/marker_names
   * @secure
   */
  projectMarkersGetMarkerNamesForProject = (projectId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/marker/marker_names`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectMarkers
   * @summary Получение маркеров на скважинах по имени маркера в рамках заданного проекта
   * @request GET:/geology/project/{projectId}/marker/by_marker_name/{markerName}
   * @secure
   */
  projectMarkersGetMarkersForProjectByMarkerName = (
    projectId: string,
    markerName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectMarker[], any>({
      path: `/geology/project/${projectId}/marker/by_marker_name/${markerName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectMarkers
   * @summary Получение маркеров проектной скважины.
   * @request GET:/geology/project/{projectId}/marker/for_well/{wellId}
   * @secure
   */
  projectMarkersGetMarkersForProjectWell = (
    projectId: string,
    wellId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectMarker[], any>({
      path: `/geology/project/${projectId}/marker/for_well/${wellId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectMarkers
 * @summary Добавляет маркеры в проект, привязывая их к скважинам.
При необходимости скважины будут добавлены к проекту.
 * @request POST:/geology/project/{projectId}/marker/with-well
 * @secure
 */
  projectMarkersAddMarkersToProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/marker/with-well`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectMarkers
 * @summary Добавляет маркеры в проект, привязывая их к скважинам.
При необходимости скважины будут добавлены к проекту.
 * @request POST:/geology/project/{projectId}/marker/for_fields
 * @secure
 */
  projectMarkersAddFieldMarkersToProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/marker/for_fields`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectMarkers
   * @summary Удалит маркеры из проекта, не удаляя сами маркеры из БД.
   * @request PATCH:/geology/project/{projectId}/marker/remove
   * @secure
   */
  projectMarkersRemoveMarkersFromProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<number, any>({
      path: `/geology/project/${projectId}/marker/remove`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectMarkers
   * @summary Создаёт проектные маркеры.
   * @request POST:/geology/project/{projectId}/marker/create
   * @secure
   */
  projectMarkersCreateProjectMarkers = (
    projectId: string,
    data: ProjectMarkersCreateParameters,
    params: RequestParams = {},
  ) =>
    this.http.request<MarkerCreationResult[], any>({
      path: `/geology/project/${projectId}/marker/create`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * @description Если абсолютная глубина в параметрах перемещения отсутствует - пытаемся вычислить её по инклинометрии
   *
   * @tags ProjectMarkers
   * @summary Изменение глубины маркера.
   * @request PATCH:/geology/project/{projectId}/marker/{projectMarkerId}
   * @secure
   */
  projectMarkersMoveProjectMarker = (
    projectId: string,
    projectMarkerId: string,
    data: MarkerChangeParameters,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/marker/${projectMarkerId}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    })
}
